import { Localized } from "@fluent/react"
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useState } from "react"
import { useAppDispatch } from "../../../app/hooks"
import { deleteURSRequirement, URSRequirement } from "../UrsSlice"
import { DeleteButton } from "../../../app/components/DeleteButton"
import { CancelButton } from "../../../app/components/CancelButton"

export interface SimpleDeleteUrsRequirementDialogProps {
    entity: URSRequirement
    typeCode: string
    typeName: string
    onSuccess: () => void
    onCancel: () => void
}
export const SimpleDeleteUrsRequirementDialog = ({ entity, typeCode, typeName, onSuccess, onCancel }: SimpleDeleteUrsRequirementDialogProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const handleConfirmDelClick = async () => {
        setSaving(true)
        dispatch(deleteURSRequirement(entity)).unwrap().catch(e => console.log(e)).then(() => setSaving(false)).finally(() => onSuccess())
    }
    const handleCancelDelClick = () => {
        onCancel()
    }

    return <Dialog open={true}>
        <DialogTitle
            sx={theme => ({
                bgcolor: theme.palette.grey[100],
                borderBottom: `1px solid ${theme.palette.divider}`,
                fontWeight: 600,
            })}
        >
            <Localized id="confirm-delete">
                <span>Czy na pewno chcesz usunąć to wymaganie?</span>
            </Localized>
        </DialogTitle>
        <DialogContent dividers>
            <Box
                sx={theme => ({
                    p: 1.5,
                    borderRadius: 1,
                    bgcolor: theme.palette.grey[100],
                    border: `1px solid ${theme.palette.grey[300]}`,
                })}
            >
                <Typography variant="body2" fontWeight={600}>
                    {typeCode} ({typeName})
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                    {entity.numeration}
                </Typography>

                <Typography variant="body2">
                    <span
                        dangerouslySetInnerHTML={{ __html: entity?.name }}
                    />
                </Typography>
            </Box>
        </DialogContent>
        <DialogActions>
            <DeleteButton loading={saving} onClick={handleConfirmDelClick}></DeleteButton>
            <CancelButton loading={saving} onClick={handleCancelDelClick}></CancelButton>
        </DialogActions>
    </Dialog>
}
